class ThemeGtm extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.handleTrackingClicks = this.handleTrackingClicks.bind(this)

    this.listeners.add(document, 'click', this.handleTrackingClicks)
  }

  handleTrackingClicks (event) {
    const clickedGtmEl = event.target.closest('[data-theme-gtm-el]')

    if (!clickedGtmEl) return

    if (clickedGtmEl.dataset.themeGtmEl === 'breadcrumb') {
      this.handleBreadcrumbClick(clickedGtmEl)
    }
    if (clickedGtmEl.dataset.themeGtmEl === 'contact') {
      this.handleContactClick(clickedGtmEl)
    }
    if (clickedGtmEl.dataset.themeGtmEl === 'navigation_desktop') {
      this.handleNavigationDesktopClick(clickedGtmEl)
    }
    if (clickedGtmEl.dataset.themeGtmEl === 'navigation_mobile') {
      this.handleNavigationMobileClick(clickedGtmEl)
    }
    if (clickedGtmEl.dataset.themeGtmEl === 'footer') {
      this.handleFooterClick(clickedGtmEl)
    }
  }

  handleBreadcrumbClick (clickedGtmEl) {
    try {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: clickedGtmEl.dataset.themeGtmEvent,
        target_text: clickedGtmEl.dataset.themeGtmText,
      })
    } catch (error) {
      console.error('Error pushing to dataLayer: ', error)
    }
  }

  handleContactClick (clickedGtmEl) {
    try {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: clickedGtmEl.dataset.themeGtmEvent,
        contactClick: {
          url: document.location.pathname,
          type: clickedGtmEl.dataset.themeGtmText,
        },
      })
    } catch (error) {
      console.error('Error pushing to dataLayer: ', error)
    }
  }

  handleNavigationDesktopClick (clickedGtmEl) {
    try {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: clickedGtmEl.dataset.themeGtmEvent,
        navigationClickDesktop: {
          level: clickedGtmEl.dataset.themeGtmLevel,
          category: clickedGtmEl.dataset.themeGtmCategory,
          sub_category: clickedGtmEl.dataset.themeGtmSubCategory,
          click_url: clickedGtmEl.dataset.themeGtmUrl,
          click_text: clickedGtmEl.dataset.themeGtmText,
        },
      })
    } catch (error) {
      console.error('Error pushing to dataLayer: ', error)
    }
  }

  handleNavigationMobileClick (clickedGtmEl) {
    try {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: clickedGtmEl.dataset.themeGtmEvent,
        navigationClickMobile: {
          level: clickedGtmEl.dataset.themeGtmLevel,
          category: clickedGtmEl.dataset.themeGtmCategory,
          sub_category: clickedGtmEl.dataset.themeGtmSubCategory,
          click_url: clickedGtmEl.dataset.themeGtmUrl,
          click_text: clickedGtmEl.dataset.themeGtmText,
        },
      })
    } catch (error) {
      console.error('Error pushing to dataLayer: ', error)
    }
  }

  handleFooterClick (clickedGtmEl) {
    try {
      window.dataLayer = window.dataLayer || []
      window.dataLayer.push({
        event: clickedGtmEl.dataset.themeGtmEvent,
        footerClick: {
          click_url: clickedGtmEl.dataset.themeGtmUrl,
          click_text: clickedGtmEl.dataset.themeGtmText,
        },
      })
    } catch (error) {
      console.error('Error pushing to dataLayer: ', error)
    }
  }
}

if (!customElements.get('theme-gtm')) {
  customElements.define('theme-gtm', ThemeGtm)
}
